import DataHealth from './screens/DataHealth';
import DailyMetrics from './screens/DailyMetrics';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { AuthProvider, useAuth } from './AuthContext';
import NotifSettings from './screens/NotifSettings';
import { registerSW } from './utils/webpush';
import GuestRoom from './components/GuestRoom';
import LoginGate from './LoginGate';
import SplashScreen from './SplashScreen';
import Layout from './components/Layout';
import CmdK from './components/CmdK';

import Revenue      from './screens/Revenue';
import Subscriptions from './screens/Subscriptions';
import RefundQueue from './screens/RefundQueue';
import BookingOps  from './screens/BookingOps';
import Fraud        from './screens/Fraud';
import Community    from './screens/Community';
import Saved        from './screens/Saved';
import Sana         from './screens/Sana';
import DataQuality  from './screens/DataQuality';
import LocationEditor from './screens/LocationEditor';
import Coverage     from './screens/Coverage';
import Pathways     from './screens/Pathways';
import VisaRules    from './screens/VisaRules';
import PathwayRoutes from './screens/PathwayRoutes';
import DirectoryGrowth from './screens/DirectoryGrowth';
import Featured     from './screens/Featured';
import Notices      from './screens/Notices';
import GrowthOverview from './screens/GrowthOverview';
import Waitlist     from './screens/Waitlist';
import Email        from './screens/Email';
import Social       from './screens/Social';
import Scheduler    from './screens/Scheduler';
import Abtest       from './screens/Abtest';
import UTMReferral  from './screens/UTMReferral';
import Planner      from './screens/Planner';
import Languages    from './screens/Languages';
import Roles        from './screens/Roles';
import CustomerHelp from './screens/Support';
import Moderation   from './screens/Moderation';
import ActivityLog  from './screens/ActivityLog';
import Duplicates   from './screens/Duplicates';
import Geocoding    from './screens/Geocoding';
import TravelProfiles    from './screens/TravelProfiles';
import BulkEditor        from './screens/BulkEditor';
import LocationProfile   from './screens/LocationProfile';
import LaunchReadiness   from './screens/LaunchReadiness';
import DataCompleteness  from './screens/DataCompleteness';
import TagNormalizer     from './screens/TagNormalizer';
import APICostMonitor    from './screens/APICostMonitor';
import CoveragePlanner   from './screens/CoveragePlanner';
import KnowledgeBase  from './screens/KnowledgeBase';
import UserDetail            from './screens/UserDetail';
import LocationQuality      from './screens/LocationQuality';
import TeamProductivity     from './screens/TeamProductivity';
import NotificationsCentre  from './screens/NotificationsCentre';
import PushNotifications    from './screens/PushNotifications';
import DataOps              from './screens/DataOps';
import MilestoneTracker    from './screens/MilestoneTracker';
import PassManager         from './screens/PassManager';
import AIAssistant   from './screens/AIAssistant';
import VerifyQueue   from './screens/VerifyQueue';
import SanaEditor    from './screens/SanaEditor';
import BetaAccess    from './screens/BetaAccess';
import SEO           from './screens/SEO';
import GoogleAds     from './screens/GoogleAds';
import MarketingHub  from './screens/MarketingHub';
import SyncTrigger   from './screens/SyncTrigger';
import CommsHub      from './screens/CommsHub';
import Dispatch      from './screens/Dispatch';
import Studio        from './screens/Studio';
import AppStudio     from './screens/AppStudio';
import DevSetup      from './screens/DevSetup';
import BrandKit      from './screens/BrandKit';
import TelegramScreen from './screens/Telegram';
import UsersHub        from './screens/UsersHub';
import RetentionHub    from './screens/RetentionHub';
import RevenueHub      from './screens/RevenueHub';
import RevenueConsole  from './screens/RevenueConsole';
import UsersConsole    from './screens/UsersConsole';
import RetentionConsole from './screens/RetentionConsole';
import DirectoryConsole from './screens/DirectoryConsole';
import SanaConsole     from './screens/SanaConsole';
import SystemConsole   from './screens/SystemConsole';
import DataHub         from './screens/DataHub';
import LocationsHub    from './screens/LocationsHub';
import PipelineHub     from './screens/PipelineHub';
import CampaignsHub    from './screens/CampaignsHub';
import ContentHub      from './screens/ContentHub';
import SystemHub       from './screens/SystemHub';
import TeamHub         from './screens/TeamHub';
import Directory       from './screens/Directory';
import Partners        from './screens/Partners';
import CommandCenter   from './screens/CommandCenter';
import VisaPortals     from './screens/VisaPortals';
import VisaConsole      from './screens/VisaConsole';
import PartnersConsole  from './screens/PartnersConsole';
import MarketingConsole from './screens/MarketingConsole';
import DirectoryWorkspace from './screens/DirectoryWorkspace';
import ContentWorkspace   from './screens/ContentWorkspace';
import SanaWorkspace      from './screens/SanaWorkspace';
import StudioWorkspace    from './screens/StudioWorkspace';
import UsersWorkspace     from './screens/UsersWorkspace';


// ── FloatingCallOverlay ───────────────────────────────────────────────────
function FloatingCallOverlay() {
  const [callActive, setCallActive] = React.useState(false);
  const [callInfo,   setCallInfo]   = React.useState(null);
  const [roomUrl,    setRoomUrl]    = React.useState(null);
  const [minimised,  setMinimised]  = React.useState(false);
  const [hidden,     setHidden]     = React.useState(false);
  const [muted,      setMuted]      = React.useState(false);
  const [camOff,     setCamOff]     = React.useState(false);
  const [duration,   setDuration]   = React.useState(0);
  const [loading,    setLoading]    = React.useState(false);
  const [error,      setError]      = React.useState(null);
  const [pos,        setPos]        = React.useState({ x: null, y: null });
  const dragging    = React.useRef(false);
  const dragOffset  = React.useRef({ x: 0, y: 0 });
  const panelRef     = React.useRef(null);
  const timerRef     = React.useRef(null);
  const callStartRef = React.useRef(null);  // ISO timestamp when call started
  const callSessionRef = React.useRef(null); // call_video_sessions row id
  const callObjectRef = React.useRef(null); // Daily call-object (real audio media)
  const audioElsRef = React.useRef({}); // sessionId -> <audio> for remote participants
  const DAILY_DOMAIN  = process.env.REACT_APP_DAILY_DOMAIN  || '';
  const DAILY_API_KEY = process.env.REACT_APP_DAILY_API_KEY || '';
  const F = 'system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif';

  React.useEffect(() => {
    const styleId = 'sanoire-overlay-styles';
    if (!document.getElementById(styleId)) {
      const s = document.createElement('style');
      s.id = styleId;
      s.textContent = '@keyframes soLivePulse{0%,100%{opacity:1}50%{opacity:.4}} .so-live-dot{animation:soLivePulse 1.8s ease-in-out infinite;}';
      document.head.appendChild(s);
    }
  }, []);

  React.useEffect(() => {
    function handler(e) {
      const { type, id, name, roomUrl } = e.detail || {};
      triggerCall({ type, id, name, roomUrl });
    }
    function endHandler() { endCall(); }
    function hideHandler() { setHidden(true); }
    function showHandler() { setHidden(false); }
    // CALL-FIX-08 — close call_video_sessions row if tab closes mid-call.
    // Fire-and-forget — beforeunload windows are tiny so we don't await.
    function unloadHandler() {
      if (callSessionRef.current && callStartRef.current) {
        const endedAt = new Date().toISOString();
        const durSecs = Math.floor((new Date(endedAt) - new Date(callStartRef.current)) / 1000);
        try {
          import('./supabaseClient').then(function (mod) {
            mod.supabase.from('call_video_sessions')
              .update({ ended_at: endedAt, duration_secs: durSecs, status: 'ended' })
              .eq('id', callSessionRef.current)
              .then(function () {}, function () {});
          });
        } catch (_e) {}
      }
    }
    window.addEventListener('sanoire:startcall', handler);
    window.addEventListener('sanoire:endcall',   endHandler);
    window.addEventListener('sanoire:hideoverlay', hideHandler);
    window.addEventListener('sanoire:showoverlay', showHandler);
    window.addEventListener('beforeunload',      unloadHandler);
    return () => {
      window.removeEventListener('sanoire:startcall', handler);
      window.removeEventListener('sanoire:endcall',   endHandler);
      window.removeEventListener('sanoire:hideoverlay', hideHandler);
      window.removeEventListener('sanoire:showoverlay', showHandler);
      window.removeEventListener('beforeunload',      unloadHandler);
    };
  }, []); // eslint-disable-line

  React.useEffect(() => {
    if (callActive) {
      timerRef.current = setInterval(() => {
        setDuration(d => {
          const next = d + 1;
          // Sync duration to Layout header pill
          window.dispatchEvent(new CustomEvent('sanoire:callduration', { detail: { duration: next } }));
          return next;
        });
      }, 1000);
    } else {
      clearInterval(timerRef.current);
      setDuration(0);
    }
    return () => clearInterval(timerRef.current);
  }, [callActive]);

  // CALL-MEDIA — join the Daily room as a call-object so the floating pill
  // carries REAL audio and its mute/camera buttons control real media.
  // Fully graceful: if the SDK is unavailable or join fails, the pill still
  // works exactly as before (control surface + Switch-to-video).
  React.useEffect(() => {
    if (!callActive || !roomUrl) return;
    let cancelled = false;
    (async () => {
      try {
        const mod = await import('@daily-co/daily-js');
        if (cancelled) return;
        const Daily = mod.default || mod;
        teardownCall();
        const co = Daily.createCallObject({ audioSource: true, videoSource: false });
        callObjectRef.current = co;
        const attach = (participant, track) => {
          if (!participant || participant.local || !track || track.kind !== 'audio') return;
          const sid = participant.session_id;
          let el = audioElsRef.current[sid];
          if (!el) { el = document.createElement('audio'); el.autoplay = true; el.setAttribute('playsinline', ''); document.body.appendChild(el); audioElsRef.current[sid] = el; }
          try { el.srcObject = new MediaStream([track]); const p = el.play(); if (p && p.catch) p.catch(() => {}); } catch (_e) {}
        };
        const detach = (sid) => { const el = audioElsRef.current[sid]; if (el) { try { el.srcObject = null; el.remove(); } catch (_e) {} delete audioElsRef.current[sid]; } };
        co.on('track-started', (ev) => attach(ev.participant, ev.track));
        co.on('track-stopped', (ev) => { if (ev.participant && ev.track && ev.track.kind === 'audio') detach(ev.participant.session_id); });
        co.on('participant-left', (ev) => { if (ev.participant) detach(ev.participant.session_id); });
        await co.join({ url: roomUrl, startVideoOff: true, startAudioOff: false });
        if (cancelled) { teardownCall(); return; }
        try { co.setLocalAudio(!muted); co.setLocalVideo(!camOff); } catch (_e) {}
      } catch (_e) { /* SDK missing or join failed — pill remains a control surface */ }
    })();
    return () => { cancelled = true; };
  }, [callActive, roomUrl]); // eslint-disable-line

  React.useEffect(() => { try { if (callObjectRef.current) callObjectRef.current.setLocalAudio(!muted); } catch (_e) {} }, [muted]);
  React.useEffect(() => { try { if (callObjectRef.current) callObjectRef.current.setLocalVideo(!camOff); } catch (_e) {} }, [camOff]);

  function teardownCall() {
    const co = callObjectRef.current;
    if (co) { try { co.leave(); } catch (_e) {} try { co.destroy(); } catch (_e) {} callObjectRef.current = null; }
    Object.keys(audioElsRef.current).forEach(sid => { const el = audioElsRef.current[sid]; if (el) { try { el.srcObject = null; el.remove(); } catch (_e) {} } });
    audioElsRef.current = {};
  }

  async function triggerCall(info) {
    // MEETING-DIRECT (June 2026) — calendar meetings open the FULL Team Room
    // video immediately, not the floating audio pill. The planner's Join passes
    // type:'calendar' + a roomUrl (from /api/calendar-room); we hand straight to
    // Dispatch's sanoire:loadteamroom listener which starts the video meeting.
    if (info && info.type === 'calendar') {
      let url = info.roomUrl;
      if (!url && DAILY_DOMAIN && DAILY_API_KEY) {
        try {
          const rn = 'sanoire-' + (info.id || 'mtg') + '-' + Math.random().toString(16).slice(2, 6);
          const r = await fetch('https://api.daily.co/v1/rooms', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + DAILY_API_KEY },
            body: JSON.stringify({ name: rn, properties: { exp: Math.floor(Date.now() / 1000) + 7200 } }),
          });
          const room = await r.json();
          if (r.ok) url = room.url || ('https://' + DAILY_DOMAIN + '/' + rn);
        } catch (_e) { /* fall through */ }
      }
      if (!url) { alert('Could not start the meeting room.'); return; }
      window.dispatchEvent(new CustomEvent('sanoire:hideoverlay'));
      window.dispatchEvent(new CustomEvent('sanoire:navigate', { detail: { screen: 'communications' } }));
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('sanoire:loadteamroom', { detail: { roomUrl: url, name: info.name || 'Team Room' } }));
      }, 120);
      return;
    }
    const isMob = window.innerWidth < 768;
    const defaultX = isMob ? 8 : window.innerWidth - 300;
    const defaultY = 66;
    setPos({ x: defaultX < 0 ? 8 : defaultX, y: defaultY });
    setCallInfo(info);
    setCallActive(true);
    setMinimised(true); // start as pill — user expands if needed
    // Broadcast so Layout.js can show inline pill in header
    window.dispatchEvent(new CustomEvent('sanoire:callstate', { detail: { active: true, name: info.name, type: info.type, roomUrl: info.roomUrl || null } }));
    setMuted(false);
    setCamOff(false);
    setError(null);
    setRoomUrl(null);

    // If a roomUrl was already created by the caller (Dispatch.js), use it directly
    // Do NOT insert a new session — Dispatch already logged one to avoid duplicates
    if (info.roomUrl) {
      setRoomUrl(info.roomUrl);
      callStartRef.current = new Date().toISOString();
      callSessionRef.current = null; // no overlay-owned session; Dispatch owns it
      return;
    }

    // No pre-existing room — create one (e.g. when triggered from Team Room)
    if (!DAILY_DOMAIN || !DAILY_API_KEY) {
      setError('Add REACT_APP_DAILY_DOMAIN + REACT_APP_DAILY_API_KEY to .env');
      return;
    }
    const roomName = 'sanoire-' + (info.id || 'call') + '-' + Math.random().toString(16).slice(2, 6);
    setLoading(true);
    try {
      const res = await fetch('https://api.daily.co/v1/rooms', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + DAILY_API_KEY },
        body: JSON.stringify({ name: roomName, properties: { exp: Math.floor(Date.now() / 1000) + 7200 } }),
      });
      const room = await res.json();
      if (!res.ok) throw new Error(room.error || 'Failed to create room');
      // CALL-FIX-06 — prefer room.url from Daily.co API over constructed string.
      const newUrl = room.url || ('https://' + DAILY_DOMAIN + '/' + roomName);
      setRoomUrl(newUrl);
      // CALL-FIX-04 — broadcast new room so Layout pill can hand it off
      window.dispatchEvent(new CustomEvent('sanoire:callstate', { detail: { active: true, name: info.name, type: info.type, roomUrl: newUrl } }));

      // CALL-FIX-05 — log overlay-initiated calls to call_video_sessions
      callStartRef.current = new Date().toISOString();
      try {
        const { supabase } = await import('./supabaseClient');
        const { data: sess } = await supabase.from('call_video_sessions').insert({
          room_name: roomName,
          room_url: newUrl,
          started_by: 'Overlay',
          session_type: info.type || 'overlay',
          status: 'active',
          started_at: callStartRef.current,
        }).select().single();
        if (sess) callSessionRef.current = sess.id;
      } catch (_e) { /* non-blocking */ }
    } catch (err) {
      setError(err.message || 'Could not start call.');
    } finally {
      setLoading(false);
    }
  }

  function endCall() {
    const savedInfo = callInfo; // capture before clearing state
    teardownCall(); // leave the Daily room + drop remote audio
    // Log call end (only for overlay-owned sessions — Dispatch-owned sessions have callSessionRef=null)
    if (callSessionRef.current && callStartRef.current) {
      const endedAt  = new Date().toISOString();
      const durSecs  = Math.floor((new Date(endedAt) - new Date(callStartRef.current)) / 1000);
      import('./supabaseClient').then(({ supabase }) => {
        // Supabase v2 query builder isn't a real promise — must await it,
        // then ignore the error in a try/catch (not .catch()).
        (async () => {
          try {
            await supabase.from('call_video_sessions')
              .update({ ended_at: endedAt, duration_secs: durSecs, status: 'ended' })
              .eq('id', callSessionRef.current);
          } catch (_e) { /* swallow */ }
        })();
      });
      callSessionRef.current = null;
      callStartRef.current   = null;
    }
    setCallActive(false);
    setCallInfo(null);
    setRoomUrl(null);
    setMinimised(false);
    setMuted(false);
    setCamOff(false);
    setError(null);
    window.dispatchEvent(new CustomEvent('sanoire:callstate', { detail: { active: false } }));
    // Tell Dispatch.js to clean up its channel/DM call state
    if (savedInfo) {
      window.dispatchEvent(new CustomEvent('sanoire:overlayendcall', {
        detail: { type: savedInfo.type, id: savedInfo.id }
      }));
    }
  }

  function fmtDur(s) {
    const m = Math.floor(s / 60);
    return m + ':' + String(s % 60).padStart(2, '0');
  }

  function onMouseDown(e) {
    if (!panelRef.current) return;
    dragging.current = true;
    const rect = panelRef.current.getBoundingClientRect();
    dragOffset.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  }
  function onMouseMove(e) {
    if (!dragging.current) return;
    setPos({
      x: Math.max(0, Math.min(window.innerWidth  - Math.min(368, window.innerWidth - 16), e.clientX - dragOffset.current.x)),
      y: Math.max(0, Math.min(window.innerHeight - (minimised ? 58 : 420) - (window.innerWidth < 768 ? 70 : 0), e.clientY - dragOffset.current.y)),
    });
  }
  function onMouseUp() {
    dragging.current = false;
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  }

  if (!callActive || hidden) return null;

  const shadow = '0 24px 64px rgba(0,0,0,0.55), 0 8px 24px rgba(0,0,0,0.35), 0 0 0 1px rgba(175,225,246,0.10)';
  const callLabel = callInfo ? (callInfo.type === 'dm' ? callInfo.name : callInfo.type === 'channel' ? '# ' + callInfo.name : callInfo.name) : 'Call';

  // ── Pill (always shown — no expanded panel for audio calls) ─────────────
  if (callActive) {
    return ReactDOM.createPortal(
      <div ref={panelRef} style={{
        position: 'fixed', left: pos.x, top: pos.y, zIndex: 9500,
        background: '#0c1e2b', borderRadius: 20,
        boxShadow: shadow, fontFamily: F,
        userSelect: 'none', overflow: 'hidden',
        border: '1px solid rgba(175,225,246,0.08)',
      }}>
        {/* Header bar */}
        <div onMouseDown={onMouseDown} style={{ display: 'flex', alignItems: 'center', gap: 7, padding: '7px 10px 6px', cursor: 'grab', borderBottom: '1px solid rgba(175,225,246,0.06)' }}>
          <span className="so-live-dot" style={{ width: 7, height: 7, borderRadius: '50%', background: '#2da06a', flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <span style={{ fontSize: 11, fontWeight: 600, color: '#e8f4fb', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>{callLabel}</span>
          </div>
          <span style={{ fontSize: 10, color: 'rgba(175,225,246,0.38)', fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>{fmtDur(duration)}</span>
          {muted && <span style={{ fontSize: 9, fontWeight: 700, background: 'rgba(239,83,80,0.18)', color: '#ef9090', borderRadius: 5, padding: '2px 6px', letterSpacing: '.04em', flexShrink: 0 }}>MUTED</span>}
        </div>
        {/* Icon dock */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px 10px 9px' }}>
          {/* Mic */}
          <button onClick={() => setMuted(m => !m)} title={muted ? 'Unmute' : 'Mute'} style={{ width: 30, height: 30, borderRadius: 9, border: 'none', background: muted ? 'rgba(239,83,80,0.22)' : 'rgba(175,225,246,0.09)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background .15s' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={muted ? '#ef7070' : '#AFE1F6'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{muted ? <><line x1="1" y1="1" x2="23" y2="23"/><path d="M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6"/><path d="M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></> : <><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></>}</svg>
          </button>
          {/* Camera */}
          <button onClick={() => setCamOff(c => !c)} title={camOff ? 'Camera on' : 'Camera off'} style={{ width: 30, height: 30, borderRadius: 9, border: 'none', background: camOff ? 'rgba(239,83,80,0.22)' : 'rgba(175,225,246,0.09)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background .15s' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={camOff ? '#ef7070' : '#AFE1F6'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{camOff ? <><path d="M16 16v1a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h2m5.66 0H14a2 2 0 012 2v3.34l1 1L23 7v10"/><line x1="1" y1="1" x2="23" y2="23"/></> : <><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></>}</svg>
          </button>
          {/* Share */}
          <button onClick={() => {
            // CALL-FIX-02 — switching to video preserves the active room and
            // hands it off to Dispatch via sanoire:loadteamroom. Previously
            // this called endCall() first, which wiped roomUrl, then dispatched
            // a navigate event nobody listened for, then a dead teamroom event
            // with no payload. Net result: pill closed, no video, no room.
            const activeRoom = roomUrl;
            teardownCall(); // hand media to Team Room — don't stay double-joined
            window.dispatchEvent(new CustomEvent('sanoire:hideoverlay'));
            window.dispatchEvent(new CustomEvent('sanoire:navigate', { detail: { screen: 'communications' } }));
            if (activeRoom) {
              setTimeout(() => {
                window.dispatchEvent(new CustomEvent('sanoire:loadteamroom', {
                  detail: { roomUrl: activeRoom, name: callInfo?.name || 'Team Room' }
                }));
              }, 80);
            }
          }} title="Switch to video" style={{ width: 30, height: 30, borderRadius: 9, border: 'none', background: 'rgba(175,225,246,0.09)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background .15s' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#AFE1F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
          </button>
          {/* End call */}
          <button onClick={endCall} title="End call" style={{ width: 30, height: 30, borderRadius: 9, border: 'none', background: '#8b1a1a', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(139,26,26,0.45)', transition: 'background .15s' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.42 19.42 0 01-3.33-2.67m-2.67-3.34a19.79 19.79 0 01-3.07-8.63A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91M23 1L1 23"/></svg>
          </button>
        </div>
      </div>,
      document.body
    );
  }

}

const SCREENS = {
  // ── Hub screens (merged) ───────────────────────────────────────────────────
  users:      UsersWorkspace,
  retention:  RetentionConsole,
  revenuehub:  RevenueConsole,
  data:       DataHub,
  locations:  LocationsHub,
  pipeline:   PipelineHub,
  campaigns:  CampaignsHub,
  content:    ContentWorkspace,
  system:     SystemConsole,
  directory:   DirectoryWorkspace,
  partners: PartnersConsole, partnerseditor: Partners, marketingconsole: MarketingConsole,
  visaportals: VisaConsole, visaportalseditor: VisaPortals,
  team:       TeamHub,
  // ── Standalone screens ─────────────────────────────────────────────────────
  command: CommandCenter,
  overview: CommandCenter, revenue: Revenue, subscriptions: Subscriptions, refundqueue: RefundQueue, bookingops: BookingOps, fraud: Fraud, community: Community, sana: SanaWorkspace,
  waitlist: Waitlist, abtest: Abtest,
  passmanager: PassManager,
  customerhelp: CustomerHelp, communications: Dispatch,
  moderation: Moderation, dispatch: Dispatch, planner: Planner, studio: StudioWorkspace, brandkit: BrandKit, appstudio: AppStudio, devsetup: DevSetup, roles: Roles, activitylog: ActivityLog,
  // ── Direct-access screens (not in nav, reachable via CmdK / hub tabs) ────
  saved: Saved,
  userdetail: UserDetail, travelprofiles: TravelProfiles,
  dataops: DataOps, dataquality: DataQuality, datacompleteness: DataCompleteness,
  duplicates: Duplicates, bulkeditor: BulkEditor, tagnormalizer: TagNormalizer,
  locationquality: LocationQuality, locationeditor: LocationEditor,
  verifyqueue: VerifyQueue, locationprofile: LocationProfile,
  coverage: Coverage, coverageplanner: CoveragePlanner, geocoding: Geocoding,
  pathways: Pathways,
  visarules: VisaRules,
  pathwayroutes: PathwayRoutes,
  directorygrowth: DirectoryGrowth,
  synctrigger: SyncTrigger,
  utm: UTMReferral,
  seo: SEO, googleads: GoogleAds, marketing: MarketingHub,
  datahealth: DataHealth,
  dailymetrics: DailyMetrics,
  growth: GrowthOverview, commshub: CommsHub,
  sanaeditor: SanaEditor, featured: Featured, notices: Notices,
  betaaccess: BetaAccess, aiassistant: AIAssistant, languages: Languages,
  milestones: MilestoneTracker,
  launchreadiness: LaunchReadiness, apicostmonitor: APICostMonitor,
  teamproductivity: TeamProductivity,
  chat: Dispatch, notifications: PushNotifications, alertscentre: NotificationsCentre, telegram: TelegramScreen, notifsettings: NotifSettings,
  knowledgebase: KnowledgeBase,
};

// AUTO-REFRESH (June 2026) — pure-analytics screens remount (= refetch) on
// window focus and every 5 minutes while visible. Interactive screens
// (Dispatch, editors, Studio, Planner, forms) are deliberately NOT listed so a
// background refresh can never wipe in-progress input.
const LIVE_REFRESH = new Set(['command','overview','revenuehub','revenue','subscriptions','users','retention','system','fraud','marketingconsole','growth','datahealth','dailymetrics','dataquality','datacompleteness','coverage','teamproductivity','apicostmonitor','launchreadiness','saved','seo','googleads']);

const G_SHORTCUTS = {
  o: 'command', r: 'revenue', d: 'data', q: 'dataquality', e: 'locationeditor',
  u: 'users', h: 'customerhelp', l: 'activitylog', w: 'waitlist', g: 'growth', s: 'system', x: 'duplicates',
};

function AdminApp() {
  const { session, loading } = useAuth();
  const [screen, setScreen]   = useState(() => {
    // Deep links: ?room= → Team Room; ?screen=<key> → that screen.
    try {
      const q = new URLSearchParams(window.location.search);
      if (q.get('room')) return 'communications';
      const s = q.get('screen');
      if (s && SCREENS[s]) return s;
      const n = q.get('notif');
      if (n === 'call') return 'communications';
      if (n === 'ticket') return 'customerhelp';
    } catch (_e) {}
    return 'command';
  });
  const [period, setPeriod]   = useState('7d');
  const [compare, setCompare] = useState(false);
  const [splashDone, setSplashDone] = useState(false);
  const [showShortcuts, setShowShortcuts] = useState(false);
  // MEETING-PERSIST (June 2026) — keep the Dispatch screen mounted while a Team
  // Room meeting is live so it survives tab changes. Navigating away used to
  // unmount Dispatch and disconnect LiveKit, closing the room. Dispatch
  // broadcasts sanoire:meetinglive whenever its video meeting starts/ends.
  const [meetingLive, setMeetingLive] = useState(false);
  useEffect(() => {
    function onML(e) { setMeetingLive(!!(e.detail && e.detail.active)); }
    window.addEventListener('sanoire:meetinglive', onML);
    return () => window.removeEventListener('sanoire:meetinglive', onML);
  }, []);
  const gPending = React.useRef(false);
  const gTimer   = React.useRef(null);

  // Expose nav fn globally so FloatingCallOverlay + incoming call can navigate
  React.useEffect(() => {
    window.sanoireNav = setScreen;
    return () => { window.sanoireNav = null; };
  }, [setScreen]);

  // Analytics auto-refresh tick (focus + 5-min interval, max once per 60s).
  const [refreshTick, setRefreshTick] = useState(0);
  const lastRefreshRef = React.useRef(Date.now());
  React.useEffect(() => {
    const bump = () => {
      if (Date.now() - lastRefreshRef.current < 60000) return;
      lastRefreshRef.current = Date.now();
      setRefreshTick(t => t + 1);
    };
    const onVis = () => { if (!document.hidden) bump(); };
    const iv = setInterval(() => { if (!document.hidden) bump(); }, 5 * 60 * 1000);
    window.addEventListener('focus', bump);
    document.addEventListener('visibilitychange', onVis);
    return () => { clearInterval(iv); window.removeEventListener('focus', bump); document.removeEventListener('visibilitychange', onVis); };
  }, []);

  // Register the push service worker so notifications work even when this tab is closed.
  React.useEffect(() => { try { registerSW(); } catch (_e) {} }, []);

  // CALL-FIX-01 (May 15, 2026) — wire up the sanoire:navigate event.
  // Previously dispatched 4+ times across App.js + Layout.js but had no
  // listener, which broke the in-call header pill, the Switch-to-video
  // button, and the incoming-call accept flow. The user stayed put.
  React.useEffect(() => {
    function onNavigate(e) {
      const screen = e.detail?.screen;
      if (screen && SCREENS[screen]) setScreen(screen);
    }
    window.addEventListener('sanoire:navigate', onNavigate);
    return () => window.removeEventListener('sanoire:navigate', onNavigate);
  }, []);

  useEffect(() => {
    if (!splashDone) return;
    function handler(e) {
      const tag = document.activeElement?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (e.key === '?') { setShowShortcuts(s => !s); return; }
      if (e.key.toLowerCase() === 'g' && !e.metaKey && !e.ctrlKey) {
        gPending.current = true;
        clearTimeout(gTimer.current);
        gTimer.current = setTimeout(() => { gPending.current = false; }, 1000);
        return;
      }
      if (gPending.current && G_SHORTCUTS[e.key.toLowerCase()]) {
        e.preventDefault();
        gPending.current = false;
        clearTimeout(gTimer.current);
        setScreen(G_SHORTCUTS[e.key.toLowerCase()]);
      }
    }
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [splashDone]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#0d1e28', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#AFE1F6', fontFamily: 'system-ui', fontSize: '.9rem' }}>
        Loading…
      </div>
    );
  }

  if (!session) {
    // External guest opening a Team Room link → server-enforced waiting room.
    try { const q = new URLSearchParams(window.location.search); if (q.get('room')) return <GuestRoom room={q.get('room')} />; } catch (_e) {}
    return <LoginGate />;
  }
  if (!splashDone) return <SplashScreen onComplete={() => setSplashDone(true)} />;

  const ScreenComponent = SCREENS[screen] || CommandCenter;

  return (
    <>
      <CmdK onNav={setScreen} session={session} />
      <FloatingCallOverlay />

      {showShortcuts && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 8900, background: 'rgba(10,22,32,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui' }}
          onClick={() => setShowShortcuts(false)}>
          <div style={{ background: '#fff', borderRadius: 14, padding: '24px 28px', width: 400, boxShadow: '0 24px 64px rgba(0,0,0,0.28)' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: '.82rem', fontWeight: 600, color: '#0f1e28', marginBottom: 16 }}>Keyboard shortcuts</div>
            {[
              ['⌘K / Ctrl+K', 'Open command palette'],
              ['G then O', 'Overview'],
              ['G then H', 'Customer Help'],
              ['G then D', 'Data Freshness'],
              ['G then R', 'Revenue'],
              ['G then U', 'Users'],
              ['G then S', 'System'],
              ['G then W', 'Waitlist'],
              ['G then G', 'Growth Overview'],
              ['G then L', 'Activity Log'],
              ['G then X', 'Data Deduplication'],
              ['?',        'Toggle this cheat sheet'],
            ].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f0f2f4' }}>
                <span style={{ fontSize: '.76rem', color: '#7a9aaa' }}>{v}</span>
                <kbd style={{ fontSize: '.68rem', background: '#f0f2f4', color: '#314F5C', padding: '3px 9px', borderRadius: 5, border: '1px solid #dde4ea', fontWeight: 600 }}>{k}</kbd>
              </div>
            ))}
            <div style={{ marginTop: 12, fontSize: '.68rem', color: '#a0b4be', textAlign: 'center' }}>Press ? or click outside to close</div>
          </div>
        </div>
      )}

      <Layout screen={screen} onNav={setScreen} session={session} period={period} onPeriod={setPeriod} compare={compare} onCompare={setCompare}>
        {(() => {
          const onDispatch = (screen === 'communications' || screen === 'dispatch' || screen === 'chat');
          const DispatchPersist = SCREENS.communications;
          return (
            <>
              {(onDispatch || meetingLive) && (
                <div style={{ display: onDispatch ? 'contents' : 'none' }}>
                  <DispatchPersist key="persistent-dispatch" compare={compare} period={period} session={session} onNav={setScreen} />
                </div>
              )}
              {!onDispatch && (
                <ScreenComponent key={LIVE_REFRESH.has(screen) ? screen + ':' + refreshTick : screen} compare={compare} period={period} session={session} onNav={setScreen} />
              )}
              {meetingLive && !onDispatch && (
                <button onClick={() => setScreen('communications')}
                  style={{ position: 'fixed', bottom: 18, left: '50%', transform: 'translateX(-50%)', zIndex: 9000, background: '#0d1d2b', color: '#E0F5FC', border: '1px solid rgba(175,225,246,0.25)', borderRadius: 999, padding: '10px 18px', fontSize: 13, fontWeight: 600, fontFamily: 'system-ui,-apple-system,sans-serif', cursor: 'pointer', boxShadow: '0 8px 24px rgba(13,29,43,0.4)', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2da06a', boxShadow: '0 0 0 3px rgba(45,160,106,0.3)' }} />
                  Return to meeting
                </button>
              )}
            </>
          );
        })()}
      </Layout>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AdminApp />
    </AuthProvider>
  );
}

